import React from 'react';
// import { ArrowRight, MapPin } from 'lucide-react'; // Needed only by the hidden sections below
// import { Button } from '../components/ui/button';
import { stats /* , insights */ } from '../mock';

// NOTE: This file renders three sections:
//   1) Stats banner (VISIBLE)
//   2) Process Intelligence Days / Events (TEMPORARILY HIDDEN — re-enable when ready)
//   3) Insights cards (TEMPORARILY HIDDEN — re-enable when ready)
// The hidden sections are kept below as commented blocks so they can be re-enabled later.

const Insights = () => {
  return (
    <>
      {/* Stats */}
      <section id="insights" className="bg-gradient-to-r from-neutral-100 via-blue-200 to-blue-500 scroll-mt-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((s) => (
              <div key={s.label}>
                <div className="text-[44px] lg:text-[60px] font-semibold leading-none tracking-[-0.02em] text-neutral-950">{s.value}</div>
                <div className="mt-3 text-[13px] text-neutral-800 max-w-[200px]">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ------------------------------------------------------------------
         TEMPORARILY HIDDEN — Process Intelligence Days (Events)
         To re-enable: uncomment this block and the lucide/Button imports above.
         ------------------------------------------------------------------ */}
      {/*
      <section className="bg-[#0a0a0a]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24">
          <div className="grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-5">
              <p className="text-[13px] uppercase tracking-[0.18em] text-neutral-500">Process Intelligence Days</p>
              <h2 className="mt-3 text-[36px] lg:text-[48px] leading-[1.05] tracking-[-0.02em] font-semibold text-white">
                It's time to industrialize <span className="italic font-light text-neutral-400">Enterprise AI.</span>
              </h2>
              <p className="mt-5 text-[16px] text-neutral-300 leading-relaxed max-w-md">
                24 cities. 6 continents. Discover live how to industrialize Enterprise AI — with Process Intelligence. Register now.
              </p>
              <Button className="mt-7 h-12 px-6 rounded-full bg-white hover:bg-neutral-200 text-neutral-950 text-[14px] font-medium inline-flex items-center gap-2">
                See all stops <ArrowRight className="w-4 h-4" />
              </Button>
            </div>
            <div className="lg:col-span-7">
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {['New York','London','Berlin','Tokyo','Singapore','Sydney','Mumbai','São Paulo','Dubai'].map((c) => (
                  <div key={c} className="rounded-xl border border-neutral-800 bg-neutral-950 p-4 hover:border-blue-500 transition-colors">
                    <MapPin className="w-4 h-4 text-neutral-500" />
                    <div className="mt-2 text-[15px] font-medium text-white">{c}</div>
                    <div className="text-[12px] text-neutral-500">Process Intelligence Day</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      */}

      {/* ------------------------------------------------------------------
         TEMPORARILY HIDDEN — Insights cards
         To re-enable: uncomment this block and the `insights` import above.
         ------------------------------------------------------------------ */}
      {/*
      <section className="bg-black">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24">
          <div className="flex items-end justify-between mb-10">
            <div>
              <p className="text-[13px] uppercase tracking-[0.18em] text-neutral-500">Insights</p>
              <h2 className="mt-3 text-[40px] lg:text-[52px] leading-[1.02] tracking-[-0.02em] font-semibold text-white">Ready to learn more?</h2>
            </div>
            <a href="#" className="hidden md:inline-flex items-center gap-2 text-[14px] font-medium text-white group">
              See all <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </a>
          </div>
          <div className="grid md:grid-cols-3 gap-5">
            {insights.map((c) => (
              <article key={c.title} className="group rounded-2xl overflow-hidden border border-neutral-800 hover:border-blue-500 transition-colors bg-neutral-950">
                <div className="aspect-[16/10] overflow-hidden bg-neutral-900">
                  <img src={c.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 opacity-90" />
                </div>
                <div className="p-6">
                  <p className="text-[12px] uppercase tracking-wider text-neutral-500">{c.badge}</p>
                  <h3 className="mt-2 text-[18px] font-semibold text-white leading-snug">{c.title}</h3>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-[13px] font-medium text-white">
                    {c.cta} <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
      */}
    </>
  );
};

export default Insights;
